import React from "react";
import Loading from "Components/Loading";
import { Input } from "Components/Form";
import { Field, reduxForm } from "redux-form";
import { ButtonBrand, ButtonPrimary } from "Components/Button";
import { LiveSearchSimple } from "../../../../Components/Form/LiveSearch/LiveSearchSimple";
import { venueInteraction } from "../../../../modules/analytics";
import { connect } from "react-redux";
import { isRolePlatformAdmin, token } from "../../../../modules/auth";
import { withRouter, Link } from "react-router-dom";
const VenueSearchField = props => {
  return (
    <form onSubmit={props.handleSubmit}>
      <Field component={Input} label="Find venue" name="venue_search_field" />
      <div className="flex justify-between">
        {props.loading ? (
          <Loading inline />
        ) : (
          <ButtonBrand type="submit">Search</ButtonBrand>
        )}

        {props.searchResults.length > 0 && (
          <ButtonPrimary onClick={props.clear}>Clear</ButtonPrimary>
        )}
      </div>
    </form>
  );
};

export default withRouter(
  reduxForm({
    form: "SearchVenuesForm",
    destroyOnUnmount: false,
  })(
    connect(state => {
      return {
        token: token(state),
        isRolePlatformAdmin: isRolePlatformAdmin(state),
      };
    }, {})(VenueSearchField)
  )
);
